module.exports = __webpack_public_path__ + "img/icons-status-success.e1326bdf.svg";